import _ from 'lodash';
import { SegmentAbstraction } from '@nerdwallet/seo-analytics';
import { SegmentEventTrackerT } from './types';
import { EventType, FORM_FIELD_INTERACTED } from './event-types';
import { SegmentAttributes } from './segment-impression';

/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable camelcase */

export type SegmentEventPayloadT = {
  deployable_name: string;
  deployable_version: string;
  event_id: string;
} & SegmentAttributes<EventType>;

export const trackViewedImpression: SegmentEventTrackerT<
  SegmentEventPayloadT,
  void
> = (eventType, payload, segmentInstance) => {
  segmentInstance.track(eventType, {
    ...payload,
  });
};

export type SegmentFormInputEventPayloadT = {
  entityName: string;
  field: string;
  field_value: unknown | undefined;
  field_type:
    | 'user_type_input'
    | 'expand-contract'
    | 'checkbox'
    | 'tab_switch'
    | 'increment-decrement-user_type_input'
    | 'radio'
    | 'slide'
    | 'drop-down'
    | 'click'
    | 'single_selection';
  additional_attributes?: Record<string, unknown>[];
};

export const trackInputEvent: SegmentEventTrackerT<
  SegmentFormInputEventPayloadT,
  void
> = (
  eventType,
  { entityName, field, field_value, field_type, additional_attributes },
  segmentInstance
) => {
  if (
    _.isFinite(field_value) ||
    typeof field_value === 'boolean' ||
    (typeof field_value === 'string' && field_value !== '')
  ) {
    segmentInstance.track(eventType, {
      additional_attributes: additional_attributes || [],
      entity_name: entityName,
      field,
      field_type,
      field_value,
    });
  }
};

export const debouncedTrackInputEvent: (
  data: SegmentFormInputEventPayloadT,
  segmentInstance: Pick<SegmentAbstraction, 'track'>
) => void = _.debounce((data, segmentInstance) => {
  trackInputEvent(FORM_FIELD_INTERACTED, data, segmentInstance);
}, 1000);
